import { render } from 'lit-html';
import { MySearchesComponent } from '../../../mySearches';
import { TopToolsLinkMenuDesktopComponent } from '../../../topToolsLinkMenuDesktop';
import { TopToolsLinkMenuMobileComponent } from '../../../topToolsLinkMenuMobile';
import { isEmptySearch } from '../../../../service/search-service';
import { replaceStringPlaceholders, decodeHTMLEntities, getHtmlElementByClass } from '../../../../utils';
import { searchFormatter } from '../../../../utils/formatters';
import StatementDescriptionTemplate from "../templates/statementDescription";



const composeMessage = (
  formattedSearch: string,
  totalResults: number,
  message: string): string => decodeHTMLEntities(
    replaceStringPlaceholders(message, [formattedSearch, totalResults.toString()])
  );

const composeDistance = (
  radiusValue: string,
  radiusUnit: string,
  autoexpanded: string): Readonly<Distance> | undefined => ({
    text: radiusValue ? `${radiusValue} ${radiusUnit}` : '',
    value: radiusValue || 'auto',
    autoexpanded: autoexpanded === 'true'
  });

const updateProvider = (
  what: string,
  where: string,
  jrConfigGlobal: Readonly<JrConfigGlobal>): string => {
  const {
    search: {
      totalResults,
      radius: {
        autoexpanded,
        value: radiusValue,
        unit: radiusUnit
      }
    }
  } = jrConfigGlobal;

  const formattedSearch = searchFormatter({
    what,
    where,
    rewrittenWhere: undefined,
    distance: composeDistance(radiusValue, radiusUnit, autoexpanded)
  });

  return composeMessage(
    formattedSearch,
    totalResults,
    jrConfigGlobal.messages.JobSeekerSubscriptionDialogInfo);
}

const composeProvider = (jrConfigGlobal: Readonly<JrConfigGlobal>): string => {
  const {
    search: {
      totalResults,
      what: { term: whatValue },
      where: { term: whereValue, rewritten: rewrittenWhere },
      radius: {
        autoexpanded,
        value: radiusValue,
        unit: radiusUnit
      }
    },
  } = jrConfigGlobal;

  const formattedSearch = searchFormatter({
    what: whatValue,
    where: whereValue,
    rewrittenWhere,
    distance: composeDistance(radiusValue, radiusUnit, autoexpanded)
  });

  return composeMessage(
    formattedSearch,
    totalResults,
    jrConfigGlobal.messages.JobSeekerSubscriptionDialogInfo
  );
}

export const proposalConfigs = (jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal): ProposalConfigs => {
  const {
    feature,
    captcha,
    messages,
    subscription,
    page,
    isMobile,
    socialLogin
  } = jrConfigGlobal;

  return {
    isEmptySearch: isEmptySearch(),
    messages,
    feature,
    captcha,
    subscription,
    page,
    isMobile,
    socialLogin
  }
};

export const composeDescription = (jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal): string => {
  const {
    messages,
    page: { isJobPreviewPage }
  } = jrConfigGlobal;

  return (isEmptySearch() && !isJobPreviewPage) || isJobPreviewPage
    ? messages.JobSeekerSubscriptionExtendedDialogInfo
    : composeProvider(jrConfigGlobal);
}


export const updateDescription = (
  what: string,
  where: string,
  jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal): string => updateProvider(
    what,
    where,
    jrConfigGlobal);


export const renderTopToolsLinkMenuDesktopComponent = (props: ITopToolsLinkMenu): void => render(TopToolsLinkMenuDesktopComponent(props), getHtmlElementByClass('jobseeker-account-wrapper'));

export const renderTopToolsLinkMenuMobileComponent = (props: ITopToolsLinkMenu): void => render(TopToolsLinkMenuMobileComponent(props), getHtmlElementByClass('jobseeker-account-wrapper'));

export const renderMySearchesComponent = (props: IMySearchesComponent): void => render(MySearchesComponent(props), getHtmlElementByClass('js-my-searches-wrapper'));

export const renderStatementDescriptionTemplate = (description: string): void => render(StatementDescriptionTemplate(description), getHtmlElementByClass('description-wrapper'));